import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Nav, NavItem } from '@feathr/components';
import { useLocalUrl } from '@feathr/extender/state';
import { getEventIdFromUrl } from '@feathr/extender/utils';

function EventPartnersNav(): JSX.Element {
  const localUrl = useLocalUrl();
  const eventId = getEventIdFromUrl();
  const { t } = useTranslation();

  return (
    <Nav indented={true} label={'Project partners navigation'} type={'vertical'}>
      <NavItem
        data-command={'true'}
        data-command-description={t('View partner activity and engagement')}
        data-command-keywords={'activity,partners,engagement'}
        data-command-label={t('Partner Activity')}
        to={localUrl(`/projects/${eventId}/partners/activity`)}
      >
        {t('Activity')}
      </NavItem>
      <NavItem
        data-command={'true'}
        data-command-description={t('Manage partner messages')}
        data-command-keywords={'messages,partners,communication'}
        data-command-label={t('Partner Messages')}
        to={localUrl(`/projects/${eventId}/partners/messages`)}
      >
        {t('Messages')}
      </NavItem>
      <NavItem
        data-command={'true'}
        data-command-description={t('Import partner data')}
        data-command-keywords={'imports,partners,data'}
        data-command-label={t('Partner Imports')}
        to={localUrl(`/projects/${eventId}/partners/imports`)}
      >
        {t('Imports')}
      </NavItem>
      <NavItem
        data-command={'true'}
        data-command-description={t('Export partner data')}
        data-command-keywords={'exports,partners,data'}
        data-command-label={t('Partner Exports')}
        to={localUrl(`/projects/${eventId}/partners/exports`)}
      >
        {t('Exports')}
      </NavItem>
      <NavItem
        data-command={'true'}
        data-command-description={t('Manage partner custom fields')}
        data-command-keywords={'fields,custom,partners'}
        data-command-label={t('Partner Custom Fields')}
        to={localUrl(`/projects/${eventId}/partners/fields`)}
      >
        {t('Custom Fields')}
      </NavItem>
      <NavItem
        data-command={'true'}
        data-command-description={t('Configure partner dashboard settings')}
        data-command-keywords={'dashboard,settings,partners'}
        data-command-label={t('Partner Dashboard Settings')}
        to={localUrl(`/projects/${eventId}/partners/dashboard`)}
      >
        {t('Dashboard Settings')}
      </NavItem>
    </Nav>
  );
}

export default EventPartnersNav;
